exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-tags .dropdown-menu{margin-top:-5px!important}.dropdown-tags .dropdown-menu.dropdown-bottom:before{border-bottom-color:#eceff9!important}.dropdown-tags .dropdown-menu .dropdown-body{padding:5px 10px}.dropdown-tags .dropdown-menu .dropdown-body ul li{padding:2px 0;cursor:pointer}", ""]);

// exports
